import { isPrivateRoute } from '@/components/seo/PrivateRouteMetadata';
const CHOICES = ['situation', 'charger', 'installation', 'plan', 'postal', 'subscription_f', 'charger_brand', 'car_brand', 'mode'];
const CORE = ['/', '/en', '/forside', '/home', '/elaftale', '/en/electricity-deal', '/opladere', '/en/chargers', '/el-fordele', '/en/electricity-benefits', '/understoettede-bilmaerker', '/en/supported-car-brands'];
const GUIDES = ['kan-alle-faa-stroem-fra-enkel', 'virker-enkel-med-alle-ladebokse', 'hvad-koster-installation-af-ladeboks', 'kan-jeg-koebe-ladeboks-uden-el-aftale', 'er-enkel-klar-til-15-minutters-afregning', 'hvor-lang-tid-tager-det-at-skifte', 'skal-jeg-opsige-hos-mit-nuvaerende-elselskab', 'hvilken-ladeboks-skal-jeg-vaelge', 'hvad-koster-el-gennem-enkel', 'saadan-fungerer-el-markedet', 'forstaa-din-elregning'];
export function hasGuideBreadcrumbs(pathname) {
  return GUIDES.includes(pathname.toLowerCase().replace(/\/$/, '').slice(1));
}
export function journeyKind(pathname) {
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/';
  if (isPrivateRoute(path)) return null;
  if (CORE.includes(path)) return 'core';
  if (['/zaptec-go', '/zaptec-go-2', '/nexblue-edge-2', '/nexblue-zen-stromsensor'].includes(path)) return 'product';
  if (['/supportkundeportal', '/kontakt', '/faq', '/en/support', '/service-aftale', '/en/service-agreement', '/henvisning'].includes(path)) return 'support';
  if (['/leveringsbetingelser', '/privatlivspolitik', '/cookiepolitik', '/gebyrer', '/smart-charge-prisgaranti-vilkaar'].includes(path)) return 'legal';
  if (path.startsWith('/blog') || path.startsWith('/en/blog') || path === '/elbilejeres-guldaeg' || GUIDES.includes(path.slice(1)) || path === '/sammenlign' || path.startsWith('/sammenlign/')) return 'reading';
  if (['/about', '/about-en', '/portal/smart-charge', '/en/smart-charge-price-guarantee', '/pris-time-for-time', '/en/electricity-price-hour-by-hour', '/elpris-sammenligning', '/en/compare-electricity-companies', '/pris-widgets', '/sitemap', '/pioneers'].includes(path)) return 'information';
  return null;
}
export function journeyUrl(to, preferCurrent = false) {
  if (typeof to !== 'string' || !to.startsWith('/') || to.startsWith('//')) return to;
  const url = new URL(to, window.location.origin);
  const checkout = /^\/(?:en\/)?ny-checkout\/?$/i.test(url.pathname);
  if (!checkout && !journeyKind(url.pathname)) return to;
  const current = new URLSearchParams(window.location.search);
  CHOICES.forEach(key => {
    if (preferCurrent) url.searchParams.delete(key);
    if (current.has(key) && (preferCurrent || !url.searchParams.has(key))) url.searchParams.set(key, current.get(key));
  });
  const situation = url.searchParams.get('situation');
  if (['no_ev', 'have_compatible', 'have_other'].includes(situation)) {
    url.searchParams.delete('installation');
    if (url.searchParams.get('modal') !== 'specs') url.searchParams.delete('charger');
  }
  if (situation === 'no_ev') ['charger_brand', 'car_brand'].forEach(key => url.searchParams.delete(key));
  if (situation === 'buy') url.searchParams.set('charger_brand', 'new');
  if (url.searchParams.get('plan') === '1') url.searchParams.delete('subscription_f');
  return url.pathname + url.search + url.hash;
}
export function journeyParent(pathname) {
  const path = pathname.toLowerCase();
  const en = path.startsWith('/en/') || path === '/about-en';
  if (journeyKind(path) === 'product') return en ? '/en/chargers' : '/opladere';
  if (path.startsWith('/en/blog/')) return '/en/blog';
  if (path.startsWith('/blog') && path !== '/blog') return '/blog';
  if (path.startsWith('/sammenlign/')) return '/sammenlign';
  return en ? '/en' : '/';
}